import script from "./AbonTable.vue?vue&type=script&lang=js"
export * from "./AbonTable.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__